import { render, staticRenderFns } from "./VisitStatusFreeze.vue?vue&type=template&id=5590c6d6&scoped=true&"
import script from "./VisitStatusFreeze.vue?vue&type=script&lang=js&"
export * from "./VisitStatusFreeze.vue?vue&type=script&lang=js&"
import style0 from "./VisitStatusFreeze.vue?vue&type=style&index=0&id=5590c6d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5590c6d6",
  null
  
)

export default component.exports